module.exports = __webpack_public_path__ + "media/images/app/arrow-3536151b84ca834ae4b61ba807de42a2.svg";